(() => {
  const initialize = (root) => {
    if (!root || root.dataset.fybloInitialized === 'true') return;
    root.dataset.fybloInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-fyblo-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-fyblo-panel]'));

    const activateTab = (nextTab, moveFocus = false) => {
      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.fybloPanel !== nextTab.dataset.fybloTab;
      });

      if (moveFocus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (typeof nextIndex !== 'number') return;

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    root.querySelectorAll('.fyblo-mobile-menu a').forEach((link) => {
      link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
    });

    const renderCartCount = (itemCount) => {
      root.querySelectorAll('[data-fyblo-cart-count]').forEach((count) => {
        count.textContent = itemCount;
        count.closest('a')?.setAttribute('aria-label', `View bag, ${itemCount} items`);
      });
    };

    const updateCartCount = async () => {
      try {
        const cartPath = `${window.routes?.cart_url || '/cart'}.js`;
        const response = await fetch(cartPath, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        renderCartCount(cart.item_count);
      } catch (_error) {
        // The native cart and form remain fully functional if the count refresh fails.
      }
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (Number.isInteger(event?.cartData?.item_count)) {
          renderCartCount(event.cartData.item_count);
          return;
        }

        window.setTimeout(updateCartCount, 0);
      });
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-fyblo-home]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
